<script setup>
import { getActionTypeFromStatus } from '@/Common/Enum/ActionType.js';
import ExpandablePill from '@/Components/ExpandablePill.vue';
import StatusIcon from '@/Pages/Common/StatusIcon.vue';
import ExplainDkimRecord from '@/Pages/DomainAnalysis/Partials/ExplainDkimRecord.vue';
import Card from '@/Components/Card/Card.vue';
import ExplainDirectivePart from '@/Pages/DomainAnalysis/Partials/ExplainDirectivePart.vue';

defineProps({
  selectors: Array,
  domain: String
});
</script>

<template>
  <div class="mt-2 flex flex-col gap-2">
    <ExpandablePill v-for="(selector, index) in selectors" :key="index">
      <template #default="{ expanded }">
        <div class="flex flex-1 justify-between">
          <div class="flex" :class="{ truncate: !expanded }">
            <div class="pr-2 font-bold">{{ selector.record.selector }}</div>
            <div
              :class="{
                'text-pretty break-all whitespace-normal': expanded,
                truncate: !expanded
              }"
              class="font-mono"
            >
              {{ selector.record.entries[0] }}
            </div>
          </div>
          <div class="pl-4">
            <StatusIcon
              :action-type="getActionTypeFromStatus(selector.status)"
            />
          </div>
        </div>
      </template>

      <template #expandable>
        <Card class="bg-white-500 mt-2 text-sm">
          <div class="flex flex-col gap-4">
            <ExplainDkimRecord :record="selector" />
          </div>
        </Card>
        <div class="flex flex-col gap-2 p-4 text-sm md:px-8">
          <ExplainDirectivePart
            :title="$t('explain.dkim.selector')"
            :directive="{
              checks: [],
              value: selector.record.selector
            }"
          />
          <ExplainDirectivePart
            :title="$t('explain.dkim.key_length')"
            :directive="{
              checks: [],
              value: selector.summary.key_length
            }"
          />
          <div
            v-for="(cname, idx) in selector.record.cnames"
            :key="idx"
            class="flex flex-col gap-4 md:gap-3"
          >
            <div class="flex flex-col gap-1 md:flex-row md:gap-8">
              <div class="flex justify-between font-bold md:w-1/3">
                <div>{{ $t('explain.dkim.cname') }}</div>
              </div>
              <div>
                <div class="break-all">
                  {{ cname.cname }}
                </div>
                <div
                  class="text-primary-600 hover:text-primary-500 text-sm underline"
                >
                  <a
                    :href="
                      route('explain.dkim', [domain, selector.record.selector])
                    "
                  >
                    {{ $t('explain.dkim.lookup') }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </ExpandablePill>
  </div>
</template>
